module.exports = __webpack_public_path__ + "static/media/google.b6e53cb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/google.svg
// module id = 252
// module chunks = 0